
import React from 'react'
import SelectField from './SelectField'

// TODO: automate based on country selected

const options = [
  ["Australian Business Number (AU ABN)", "au_abn"],
  ["Brazilian CNPJ number", "br_cnpj"],
  ["Brazilian CPF number", "br_cpf"],
  ["Canadian BN", "ca_bn"],
  ["Canadian QST number", "ca_qst"],
  ["Chilean TIN", "cl_tin"],
  ["European VAT number", "eu_vat"],
  ["Hong Kong BR number", "hk_br"],
  ["Indian GST number", "in_gst"],
  ["Indonesian NPWP number", "id_npwp"],
  ["Japanese Corporate Number (Hōjin Bangō)", "jp_cn"],
  ["Korean BRN", "kr_brn"],
  ["Liechtensteinian UID number", "li_uid"],
  ["Malaysian FRP number", "my_frp"],
  ["Malaysian ITN", "my_itn"],
  ["Malaysian SST number", "my_sst"],
  ["Mexican RFC number", "mx_rfc"],
  ["New Zealand GST number", "nz_gst"],
  ["Norwegian VAT number", "no_vat"],
  ["Russian INN", "ru_inn"],
  ["Saudi Arabia VAT", "sa_vat"],
  ["Singaporean GST", "sg_gst"],
  ["Singaporean UEN", "sg_uen"],
  ["South African VAT number", "za_vat"],
  ["Spanish CIF number", "es_cif"],
  ["Taiwanese VAT", "tw_vat"],
  ["Thai VAT", "th_vat"],
  ["United Arab Emirates TRN", "ae_trn"],
  ["United States EIN", "us_ein"]
].map(v => {
  return {
    label: v[0],
    value: v[1],
  }
})

/**
 * TaxTypeSelect component.
 */

export default function TaxTypeSelect({ ...props }) {
  return <SelectField {...props}>
    <option value="">Select</option>
    {options.map(({ label, value }) => {
      return <option key={value} value={value}>{label}</option>
    })}
  </SelectField>
}
